import { useSelector } from 'react-redux';
import { RootState } from '../state/store';

/**
 * Extracts the HashRouter route path from a full hash path.
 * e.g. "/#/login" → "/login",  "/#/login-publicis" → "/login-publicis"
 */
export const getRoutePathFromHash = (hashPath: string | undefined): string => {
    if (!hashPath) return '/login';
    const routePath = hashPath.replace(/^\/?#/, '');
    return routePath || '/login';
};

/**
 * Returns the login route path derived from the server-supplied loginPageHashPath.
 * Falls back to "/login" when client config is not yet loaded.
 */
export const useLoginPath = (): string => {
    const loginPageHashPath = useSelector(
        (state: RootState) => state.clientConfig.data?.loginPageHashPath
    );
    return getRoutePathFromHash(loginPageHashPath);
};
